var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useContext, createContext } from "react";
var c = {
    login: function () { },
    loginWithToken: function () { },
    thirdPartyLogin: function () { },
    logout: function () { },
    loginWithMicrosoft: function () { },
    linkWithMicrosoft: function () { },
    isLoggedIn: false,
    loading: true,
    checkIfLoggedIn: function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, false];
        }); });
    },
    userHasPermission: function () { return false; }
};
var authContext = createContext(c);
function setupAuthorisation(settings) {
    var _a, _b, _c, _d;
    var ERRORS = {
        "generic": "Something went wrong.  Please try again later.",
        "invalidCredentials": "Invalid username or password.",
        "notAuthorised": "Your account is not authorised.",
        "registrationDetails": "Incorrect registration details."
    };
    if (!settings) {
        // Not sure the best way to do defaults in TSX
        settings = {
            servicePath: "API/Account/",
            localStorageKey: "salauth",
            cookieName: "SWA-Auth",
            thirdPartyAuthFunction: null
        };
    }
    var SETTINGS = {
        servicePath: (_a = settings.servicePath) !== null && _a !== void 0 ? _a : "API/Account/",
        localStorageKey: (_b = settings.localStorageKey) !== null && _b !== void 0 ? _b : "salauth",
        cookieName: (_c = settings.cookieName) !== null && _c !== void 0 ? _c : "SWA-Auth",
        thirdPartyAuthFunction: (_d = settings.thirdPartyAuthFunction) !== null && _d !== void 0 ? _d : null
    };
    var _mfaSessionContactToken;
    var _e = useState(), user = _e[0], setUser = _e[1];
    var _f = useState(false), isLoggedIn = _f[0], setLoggedIn = _f[1];
    var _g = useState(true), loading = _g[0], setLoading = _g[1];
    function determineEnvironment() {
        if (typeof document != "undefined") {
            return "web";
        }
        else if (typeof navigator != "undefined" && navigator.product === "ReactNative") {
            return "react-native";
        }
        else {
            return "node";
        }
    }
    function checkIfLoggedIn() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, hasAuthenticatedCookie()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    }
    function getCookies() {
        return __awaiter(this, void 0, void 0, function () {
            var environment, cookies, cookieResult, i, len, cookie, name, value;
            return __generator(this, function (_a) {
                environment = determineEnvironment();
                if (environment === "web") {
                    cookies = document.cookie.split("; ");
                    cookieResult = {};
                    for (i = 0, len = cookies.length; i < len; i++) {
                        cookie = cookies[i].split("=");
                        name = decodeURIComponent(cookie[0]);
                        value = decodeURIComponent(cookie[1]);
                        cookieResult[name] = {
                            name: name,
                            value: value
                        };
                    }
                    return [2 /*return*/, cookieResult];
                }
                else if (environment === "react-native") {
                    throw new Error("React Native not supported in this version");
                }
                console.warn("Could not find a supported environment for authentication");
                return [2 /*return*/, {}];
            });
        });
    }
    function hasAuthenticatedCookie() {
        return __awaiter(this, void 0, void 0, function () {
            var cookies, _i, _a, _b, key, cookie;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, getCookies()];
                    case 1:
                        cookies = _c.sent();
                        for (_i = 0, _a = Object.entries(cookies); _i < _a.length; _i++) {
                            _b = _a[_i], key = _b[0], cookie = _b[1];
                            if (key === SETTINGS.cookieName + "-P" && cookie.value === "1") {
                                return [2 /*return*/, true];
                            }
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    }
    useEffect(function () {
        (function () {
            return __awaiter(this, void 0, void 0, function () {
                var isLoggedIn, user;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setLoading(true);
                            return [4 /*yield*/, checkIfLoggedIn()];
                        case 1:
                            isLoggedIn = _a.sent();
                            setLoggedIn(isLoggedIn);
                            if (isLoggedIn) {
                                user = getUserDetails();
                                setUser(user !== null && user !== void 0 ? user : undefined);
                            }
                            setLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        })();
    }, []);
    function loginWithMicrosoft(idToken, callback) {
        if (idToken) {
            var requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", "Accept": "application/json" }
            };
            fetch("PortalFramework/Sso/" + ("LoginWithMicrosoft?idToken=" + idToken), requestOptions)
                .then(function (response) {
                response.json().then(function (jsonResponse) {
                    if (jsonResponse.success) {
                        setLoggedIn(true);
                        if (jsonResponse.contactDetails) {
                            storeUserDetails(jsonResponse.contactDetails);
                        }
                    }
                    callback(jsonResponse);
                });
            }).catch(function (err) {
                console.log("err" + err);
                var errorResponse = {
                    success: false,
                    message: err
                };
                callback(errorResponse);
            });
        }
    }
    function linkWithMicrosoft(idToken, callback) {
        if (idToken) {
            var requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", "Accept": "application/json" }
            };
            fetch("PortalFramework/Sso/" + ("LinkWithMicrosoft?idToken=" + idToken), requestOptions)
                .then(function (response) {
                response.json().then(function (jsonResponse) {
                    if (jsonResponse.success) {
                        setLoggedIn(true);
                        if (jsonResponse.contactDetails) {
                            storeUserDetails(jsonResponse.contactDetails);
                        }
                    }
                    callback(jsonResponse);
                });
            }).catch(function (err) {
                console.log("err" + err);
                var errorResponse = {
                    success: false,
                    message: err
                };
                callback(errorResponse);
            });
        }
    }
    function login(userName, password, remember, callback, mfaRequiredCallback) {
        if (remember === void 0) { remember = false; }
        fetch(SETTINGS.servicePath + "Login", {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            method: "POST",
            body: JSON.stringify({ "username": userName, "password": password, "remember": remember })
        }).then(function (response) {
            response.json().then(function (jsonResponse) {
                if (jsonResponse.success) {
                    setLoggedIn(true);
                    if (jsonResponse.contactDetails) {
                        storeUserDetails(jsonResponse.contactDetails);
                    }
                }
                else if (jsonResponse.mfaRequired && jsonResponse.mfaSessionContactToken) {
                    _mfaSessionContactToken = jsonResponse.mfaSessionContactToken;
                    // Not fully implemented
                    return;
                }
                callback(jsonResponse);
            });
        }).catch(function (err) {
            console.log("err" + err);
            var errorResponse = {
                success: false,
                message: err
            };
            callback(errorResponse);
        });
    }
    function loginWithToken(token, callback, mfaRequiredCallback, returnUrl) {
        fetch(SETTINGS.servicePath + ("LoginWithToken?token=" + token + "&returnUrl=" + returnUrl), {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            method: "GET"
        }).then(function (response) {
            response.json().then(function (jsonResponse) {
                if (jsonResponse.success) {
                    setLoggedIn(true);
                    if (jsonResponse.contactDetails) {
                        storeUserDetails(jsonResponse.contactDetails);
                    }
                }
                else if (jsonResponse.mfaRequired && jsonResponse.mfaSessionContactToken) {
                    _mfaSessionContactToken = jsonResponse.mfaSessionContactToken;
                    // Not fully implemented
                    return;
                }
                callback(jsonResponse);
            });
        }).catch(function (err) {
            console.log("err" + err);
            var errorResponse = {
                success: false,
                message: err
            };
            callback(errorResponse);
        });
    }
    function thirdPartyLogin(callback) {
        if (SETTINGS.thirdPartyAuthFunction) {
            SETTINGS.thirdPartyAuthFunction(function (response) {
                if (response.success) {
                    setLoggedIn(true);
                }
                if (response.contactDetails) {
                    storeUserDetails(response.contactDetails);
                }
                callback(response);
            });
        }
    }
    function logout(callback) {
        var _a;
        if (hasAuthenticatedCookie()) {
            fetch(SETTINGS.servicePath + "Logout", {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                method: "GET"
            }).then(function (response) {
                if (callback) {
                    callback(response);
                }
            });
        }
        localStorage.removeItem((_a = SETTINGS.localStorageKey) !== null && _a !== void 0 ? _a : "salauth");
        setUser(undefined);
        setLoggedIn(false);
    }
    function getUserDetails() {
        var _a;
        var value = localStorage[(_a = SETTINGS.localStorageKey) !== null && _a !== void 0 ? _a : "salauth"];
        if (value != null && value.length > 0) {
            return JSON.parse(value);
        }
        else {
            return null;
        }
    }
    function storeUserDetails(userDetails) {
        var _a;
        if (userDetails.permissions != null) {
            userDetails.permissions = processUserPermissions(userDetails.permissions);
        }
        localStorage[(_a = SETTINGS.localStorageKey) !== null && _a !== void 0 ? _a : "salauth"] = JSON.stringify(userDetails);
        setUser(userDetails);
    }
    function userHasPermission(securityContext, permissions) {
        if (!securityContext || !permissions) {
            return false;
        }
        var userDetails = getUserDetails();
        if (!userDetails) {
            return false;
        }
        if (typeof permissions === "string") {
            permissions = [permissions];
        }
        var userPermissions = userDetails.permissions || {};
        var securityContextPermissions = userPermissions[securityContext] || "";
        for (var i = 0, len = permissions.length; i < len; i++) {
            var permission = permissions[i];
            if (securityContextPermissions.indexOf(permission) < 0) {
                return false;
            }
        }
        return true;
    }
    function processUserPermissions(permissions) {
        var processedPermissions = {};
        for (var securityContext in permissions) {
            var newSecurityContext = securityContext;
            var newPermissions = permissions[securityContext] || "";
            if (typeof newPermissions === "string") {
                if (newPermissions.slice(-1) === ",") {
                    newPermissions = newPermissions.slice(0, -1);
                }
                processedPermissions[newSecurityContext] = newPermissions.split(",");
            }
        }
        return processedPermissions;
    }
    return {
        login: login,
        loginWithToken: loginWithToken,
        thirdPartyLogin: thirdPartyLogin,
        logout: logout,
        loginWithMicrosoft: loginWithMicrosoft,
        linkWithMicrosoft: linkWithMicrosoft,
        userHasPermission: userHasPermission,
        checkIfLoggedIn: checkIfLoggedIn,
        loading: loading,
        isLoggedIn: isLoggedIn,
        user: user
    };
}
export var useAuth = function () {
    return useContext(authContext);
};
export function AuthorisationContext(props) {
    var _a;
    var auth = setupAuthorisation((_a = props.settings) !== null && _a !== void 0 ? _a : {});
    return _jsx(authContext.Provider, __assign({ value: auth }, { children: !auth.loading && props.children }), void 0);
}
